export const INITIAL_SCORE = 0
export const TOTAL_SCORE = 'Total Score='
export const SLASH = ' / '
